import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      externalRefRules: [
        Rules.isRequired,
        (v) => Rules.maxLength(v, 40)
      ],
      notesRules: [
        (v) => Rules.maxLength(v, 150)
      ],
      dateRules: [
        Rules.isRequired
      ],
      externalRefRules: [
        Rules.isRequired,
        (v) => Rules.maxLength(v, 40)
      ],
      tipRules: [
        Rules.isRequired
      ],
      projectRules: [
        Rules.isRequired
      ],
      vehicleRules: [
        Rules.isRequired
      ],
      qtyRules: [
        Rules.isRequired,
        Rules.isNumber,
        (v) => Rules.maxLength(v, 8)
      ],
      costPriceRules: [
        Rules.isRequired,
        Rules.isNumber,
        (v) => Rules.maxLength(v, 8)
      ],
      statusRules: [
        Rules.isRequired
      ],
      spoilRules: [
        Rules.isRequired
      ],
    }
  }
}